import { createGlobalStyle } from 'styled-components';
import colors from './includes/colors';

export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  html,
  body {
    height: 100%;
    font-family: 'Roboto', sans-serif;
  }

  input::-ms-clear,
  input::-ms-reveal {
    display: none;
  }

  #root {
    display: flex;
    flex-flow: column;
  }

  .bg-blue {
    background-color: ${colors.blue};
  }
  .dds__icons {
    font-family: dds-icons;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    font-size: 27px;
    -webkit-font-smoothing: antialiased;
  }
  
  @media (max-width: 991px) {
    .navbar-collapse {
      position: fixed;
      height: 100%;
      width: 260px;
      top: 0;
      right: 0;
      background: #fff;
      z-index: 9999;
      transform: translateX(100%);
      transition: transform .35s ease;
      &.show {
        transform: translateX(0);
      }
    }
    .bg-light-gray-mobile {
      background-color: #f9f9f9;
    }
  }
  .evidon-notice-link {
    display: none;
  }

  .is-valid, .is-invalid {
    background-image: none !important;
  }
`;
